window._ = require('lodash');

try {
    window.$ = window.jQuery = require('jquery');
    window.Popper = require('@popperjs/core');
    window.bootstrap = require('bootstrap');
    // require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

const _axiosImport = require('axios');
window.axios = _axiosImport && _axiosImport.default ? _axiosImport.default : _axiosImport;

if (window.axios && window.axios.defaults && window.axios.defaults.headers && window.axios.defaults.headers.common) {
    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
}

/**
 * Browsers can restore pages from the back/forward cache with the exact DOM
 * state they had when navigation started. If a page showed the global loader
 * before submitting or redirecting, hide it when that page is restored.
 */
(function () {
    function hideGlobalLoader() {
        var loader = document.getElementById('loaderEl');
        if (loader) loader.classList.add('d-none');
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', hideGlobalLoader);
    } else {
        hideGlobalLoader();
    }

    window.addEventListener('pageshow', hideGlobalLoader);
})();

/**
 * ------------------------------------------------------------------
 * Global CSRF handling for jQuery AJAX + classic form submits.
 * - Sends X-CSRF-TOKEN on every $.ajax automatically.
 * - On 419: fetches a fresh token, updates DOM/headers, retries the
 *   failed request exactly once. Parallel 419s share one refresh.
 * - Classic forms get their hidden _token refreshed right before
 *   submit, so a form left open overnight does not 419.
 * ------------------------------------------------------------------
 */
(function () {
    if (!window.$) return;

    var $ = window.$;

    function readToken() {
        var meta = document.querySelector('meta[name="csrf-token"]');
        return meta ? meta.getAttribute('content') : '';
    }

    // Same-origin check: only attach CSRF / X-Requested-With to our own backend.
    // Cross-origin requests (Iconify CDN, third-party APIs, etc.) must NOT receive
    // X-CSRF-TOKEN — it triggers a CORS preflight that those servers reject.
    function isSameOrigin(url) {
        if (!url) return true; // no URL = current page
        try {
            // Relative URLs (/foo, foo/bar, ?x=1, #x) are always same-origin.
            if (typeof url !== 'string') {
                // Request object or URL instance
                if (typeof Request !== 'undefined' && url instanceof Request) {
                    url = url.url;
                } else if (typeof URL !== 'undefined' && url instanceof URL) {
                    url = url.href;
                } else {
                    return true;
                }
            }
            if (!/^https?:\/\//i.test(url) && !/^\/\//.test(url)) return true;
            var parsed = new URL(url, window.location.href);
            return parsed.origin === window.location.origin;
        } catch (e) {
            return true;
        }
    }

    function applyToken(token) {
        if (!token) return;
        var meta = document.querySelector('meta[name="csrf-token"]');
        if (meta) meta.setAttribute('content', token);
        document.querySelectorAll('input[name="_token"]').forEach(function (el) {
            el.value = token;
        });
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': token,
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
        if (window.axios && window.axios.defaults && window.axios.defaults.headers) {
            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        }
        if (window.config) window.config.csrfToken = token;
    }

    // Initial wiring — every $.ajax now ships X-CSRF-TOKEN automatically.
    applyToken(readToken());

    // Defensive: strip CSRF / X-Requested-With from cross-origin $.ajax calls
    // so they don't trigger a CORS preflight that third-party servers reject.
    if (typeof $.ajaxPrefilter === 'function') {
        $.ajaxPrefilter(function (options) {
            if (options.crossDomain || !isSameOrigin(options.url)) {
                options.headers = options.headers || {};
                delete options.headers['X-CSRF-TOKEN'];
                delete options.headers['X-Requested-With'];
                var origBeforeSend = options.beforeSend;
                options.beforeSend = function (xhr, settings) {
                    try {
                        xhr.setRequestHeader = (function (orig) {
                            return function (name, value) {
                                var lower = (name || '').toLowerCase();
                                if (lower === 'x-csrf-token' || lower === 'x-requested-with') return;
                                return orig.call(xhr, name, value);
                            };
                        })(xhr.setRequestHeader);
                    } catch (e) {}
                    if (typeof origBeforeSend === 'function') {
                        return origBeforeSend.apply(this, arguments);
                    }
                };
            }
        });
    }

    var isRefreshing = false;
    var refreshPromise = null;
    var queuedRetries = [];

    function refreshCsrfToken() {
        if (refreshPromise) return refreshPromise;
        isRefreshing = true;
        refreshPromise = $.ajax({
            url: '/csrf-token',
            type: 'GET',
            cache: false,
            dataType: 'json',
            // Bypass our own ajaxError logic for this internal call
            _csrfInternal: true
        }).then(function (res) {
            var token = res && res.token ? res.token : null;
            if (token) applyToken(token);
            return token;
        }).always(function () {
            isRefreshing = false;
            refreshPromise = null;
        });
        return refreshPromise;
    }

    function rewriteTokenInSettings(settings, token) {
        if (!settings || !token) return;
        if (settings.headers) {
            settings.headers['X-CSRF-TOKEN'] = token;
        }
        var data = settings.data;
        if (!data) return;
        if (typeof FormData !== 'undefined' && data instanceof FormData) {
            if (typeof data.set === 'function') data.set('_token', token);
            else data.append('_token', token);
            return;
        }
        if (typeof data === 'string') {
            if (/(^|&)_token=/.test(data)) {
                settings.data = data.replace(/(^|&)_token=[^&]*/, '$1_token=' + encodeURIComponent(token));
            } else {
                settings.data = data + (data.length ? '&' : '') + '_token=' + encodeURIComponent(token);
            }
            return;
        }
        if (typeof data === 'object') {
            if ('_token' in data) data._token = token;
        }
    }

    // Axios mirror of the jQuery 419 retry — used by Vue components / any axios caller.
    if (window.axios && window.axios.interceptors && window.axios.interceptors.response) {
        window.axios.interceptors.request.use(function (cfg) {
            cfg.headers = cfg.headers || {};
            var targetUrl = cfg.url || '';
            if (cfg.baseURL && !/^https?:\/\//i.test(targetUrl) && !/^\/\//.test(targetUrl)) {
                try { targetUrl = new URL(targetUrl, cfg.baseURL).href; } catch (e) {}
            }
            if (isSameOrigin(targetUrl) && !cfg.headers['X-CSRF-TOKEN']) {
                cfg.headers['X-CSRF-TOKEN'] = readToken();
            }
            return cfg;
        });
        window.axios.interceptors.response.use(
            function (response) { return response; },
            function (error) {
                var response = error && error.response;
                var config = error && error.config;
                if (!response || response.status !== 419 || !config || config._csrfRetried) {
                    return Promise.reject(error);
                }
                config._csrfRetried = true;
                return refreshCsrfToken().then(function (token) {
                    if (token) {
                        config.headers = config.headers || {};
                        config.headers['X-CSRF-TOKEN'] = token;
                        // Rewrite token in body if it's there
                        if (config.data instanceof FormData) {
                            if (typeof config.data.set === 'function') config.data.set('_token', token);
                            else config.data.append('_token', token);
                        } else if (typeof config.data === 'string' && /(^|&)_token=/.test(config.data)) {
                            config.data = config.data.replace(/(^|&)_token=[^&]*/, '$1_token=' + encodeURIComponent(token));
                        } else if (config.data && typeof config.data === 'object' && '_token' in config.data) {
                            config.data._token = token;
                        }
                    }
                    return window.axios.request(config);
                });
            }
        );
    }

    // Wrap window.fetch so non-jQuery callers (campaigns/details.js etc.) also retry on 419.
    if (typeof window.fetch === 'function' && !window.fetch.__csrfPatched) {
        var origFetch = window.fetch.bind(window);
        var fetchWithRetry = function (input, init) {
            init = init || {};
            init.headers = init.headers || {};
            // Normalize headers (Headers instance or plain object)
            var setHeader = function (name, value) {
                if (init.headers instanceof Headers) init.headers.set(name, value);
                else init.headers[name] = value;
            };
            var hasHeader = function (name) {
                if (init.headers instanceof Headers) return init.headers.has(name);
                var lower = name.toLowerCase();
                return Object.keys(init.headers).some(function (k) { return k.toLowerCase() === lower; });
            };
            // Only attach CSRF / X-Requested-With on same-origin requests, otherwise
            // we trigger a CORS preflight that third-party APIs (Iconify CDN, etc.) reject.
            var sameOrigin = isSameOrigin(input);
            if (sameOrigin) {
                if (!hasHeader('X-CSRF-TOKEN')) setHeader('X-CSRF-TOKEN', readToken());
                if (!hasHeader('X-Requested-With')) setHeader('X-Requested-With', 'XMLHttpRequest');
            }

            return origFetch(input, init).then(function (response) {
                if (!sameOrigin) return response;
                if (response.status !== 419 || init._csrfRetried) return response;
                init._csrfRetried = true;
                return refreshCsrfToken().then(function (token) {
                    if (!token) return response;
                    setHeader('X-CSRF-TOKEN', token);
                    if (init.body instanceof FormData) {
                        if (typeof init.body.set === 'function') init.body.set('_token', token);
                        else init.body.append('_token', token);
                    } else if (typeof init.body === 'string' && /(^|&)_token=/.test(init.body)) {
                        init.body = init.body.replace(/(^|&)_token=[^&]*/, '$1_token=' + encodeURIComponent(token));
                    }
                    return origFetch(input, init);
                });
            });
        };
        fetchWithRetry.__csrfPatched = true;
        window.fetch = fetchWithRetry;
    }

    $(document).ajaxError(function (event, jqXHR, settings) {
        if (!jqXHR || jqXHR.status !== 419) return;
        if (settings && settings._csrfInternal) return; // never retry the refresh call itself
        if (settings && settings._csrfRetried) {
            try {
                if (window.toastr) {
                    window.toastr.warning('Your session has expired. Reloading…');
                }
            } catch (e) {}
            setTimeout(function () { window.location.reload(); }, 1200);
            return;
        }

        var attempt = function (token) {
            if (!token) {
                if (window.toastr) {
                    window.toastr.error('Could not refresh session. Please reload the page.');
                }
                return;
            }
            settings._csrfRetried = true;
            rewriteTokenInSettings(settings, token);
            $.ajax(settings);
        };

        if (isRefreshing && refreshPromise) {
            queuedRetries.push(settings);
            refreshPromise.then(function (token) {
                var queue = queuedRetries.splice(0);
                queue.forEach(function (s) {
                    s._csrfRetried = true;
                    rewriteTokenInSettings(s, token);
                    $.ajax(s);
                });
            });
            return;
        }

        refreshCsrfToken().then(attempt, function () {
            if (window.toastr) {
                window.toastr.error('Could not refresh session. Please reload the page.');
            }
        });
    });

    // Surface flash messages for non-AJAX 419 redirects.
    function showSessionExpiredFlash() {
        var meta = document.querySelector('meta[name="session-expired-flash"]');
        if (!meta) return;
        var text = meta.getAttribute('content');
        if (!text) return;
        if (window.toastr) {
            window.toastr.info(text);
        }
    }

    // Pre-submit token refresh for classic (non-AJAX) forms.
    //
    // We use TWO hooks to cover every path a form submission can take:
    //   1. submit-event listener (bubble phase) — catches normal button-click
    //      submissions that go through the natural event pipeline.
    //   2. monkey-patched HTMLFormElement.prototype.submit() — catches forms
    //      that JS submits programmatically (e.g., login validates then calls
    //      form.submit() — that call BYPASSES every submit listener).
    //
    // Both honour a single dataset flag (data-csrf-refreshed) so a form is
    // refreshed at most once per submit cycle, and a 'data-no-csrf-refresh'
    // attribute lets a form opt out entirely.
    var PAGE_LOADED_AT = Date.now();
    var STALE_AFTER_MS = 5 * 60 * 1000; // 5 minutes — long enough to skip roundtrip on fast UX flows, short enough to never serve a dead form

    function needsRefresh(form) {
        if (!form || form.tagName !== 'FORM') return false;
        if (form.dataset.csrfRefreshed === '1') return false;
        if (form.hasAttribute('data-no-csrf-refresh')) return false;
        if (form.method && form.method.toLowerCase() === 'get') return false;
        if (!form.querySelector('input[name="_token"]')) return false;
        return (Date.now() - PAGE_LOADED_AT) >= STALE_AFTER_MS;
    }

    function refreshFormToken(form, onDone) {
        var tokenInput = form.querySelector('input[name="_token"]');
        $.ajax({
            url: '/csrf-token',
            type: 'GET',
            cache: false,
            dataType: 'json',
            _csrfInternal: true
        }).done(function (res) {
            if (res && res.token) {
                if (tokenInput) tokenInput.value = res.token;
                applyToken(res.token);
            }
        }).always(function () {
            form.dataset.csrfRefreshed = '1';
            onDone();
        });
    }

    function attachFormGuard() {
        // 1) Catch native (button-click) submissions in bubble phase, so any
        //    per-form validators that preventDefault have a chance to run first.
        document.addEventListener('submit', function (event) {
            if (event.defaultPrevented) return; // a page-level validator already handled it
            var form = event.target;
            if (!needsRefresh(form)) return;

            event.preventDefault();
            refreshFormToken(form, function () {
                if (typeof form.requestSubmit === 'function') {
                    form.requestSubmit();
                } else {
                    form.submit();
                }
            });
        });

        // 2) Patch form.submit() so programmatic submissions (login validator,
        //    page-specific JS, etc.) also refresh the token when stale.
        var origSubmit = HTMLFormElement.prototype.submit;
        HTMLFormElement.prototype.submit = function () {
            var form = this;
            if (!needsRefresh(form)) {
                return origSubmit.call(form);
            }
            refreshFormToken(form, function () {
                origSubmit.call(form);
            });
        };
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            attachFormGuard();
            showSessionExpiredFlash();
        });
    } else {
        attachFormGuard();
        showSessionExpiredFlash();
    }

    // Expose for manual use if some page wants to force a refresh.
    window.refreshCsrfToken = refreshCsrfToken;
})();

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
